import React from "react";
import { useState } from "react";
import { Button, CardHeader, Col, Input, Label, Row } from "reactstrap";
import swal from "sweetalert";
import { useUploadAgreementFormMutation } from "./SaathiApiSlice";
import {Spinner} from 'react-bootstrap'
import { useParams } from "react-router-dom";
import { selectCurrentUser } from "features/auth/authSlice";
import { useSelector } from "react-redux";

const SaathiUploadAgreement = ({refetch,SaathiUserData}) => {
    const {id}=useParams()
  const [selectedFile, setSelectedFile] = useState("");
  const currentUser = useSelector(selectCurrentUser);
  const [loader ,setLoader] =useState(false)

  const handleUpload = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  const [AgreementUpload,response]=useUploadAgreementFormMutation()
 

  const handleUploadAgreement = () =>{
    console.log(selectedFile , "8888855555")
    setLoader(true)

    if(selectedFile=== "") {
        swal("!!", {
            buttons: false,
            icon: "warning",
            title: "Please Upload Document first",
            timer: 1500,
          });
    }
    
    else {
        let ApplicantId = id;
        const formData = new FormData()
        formData.append("e_form", selectedFile) 
        formData.append("created_by",currentUser.sub)       

        AgreementUpload({ApplicantId,formData}) .then((response) => {
            if (response.data){
              swal("Success", {
                buttons: false,
                icon: "success",
                title: response.data.message,
                timer: 1500,
              });
              refetch()
              setLoader(false)
            }
            else if (response.error){
              swal("Error", {
                buttons: false,
                icon: "warning",
                title: response.error.data.message,
                timer: 3000,
              });
              setLoader(false)
            }
          }).catch((error) => {
            console.log("catch", error)
          });
        }
  }
  return (
    <div>

      <CardHeader style={{ padding: "13px" }} className=" mb-3">
        <h5 className="m-0">Upload Saathi Agreement Detail</h5>
      </CardHeader>

      <Row>
      <Col lg="4" className="mb-2">
        <Label>Upload  (Pdf format only *)</Label>

        <Input
          style={{fontSize:"15px"}}
          type="file"
          accept=".pdf"
          onChange={handleUpload}
          required ={SaathiUserData?.is_attached_by_agent == false ? true : false}
        />
      </Col>
      <Col lg="2" className="mt-4">
        <Button className="mt-2 bg-success border-0" onClick={handleUploadAgreement}>
            Upload <span className="mdi mdi-upload"></span> &nbsp; {loader ? <Spinner animation="border" size="sm"></Spinner> : ""}
        </Button>
      </Col>
      </Row>
    </div>
  );
};

export default SaathiUploadAgreement;
